















import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import MasterSubject from './MasterSubject.vue';

@Component({
  components: {
    MasterSubject,
  },
})
export default class SubjectsListMobile extends Vue {
  @State('selectedSubject') private stateSelectedSubject: any;
  @Mutation('setSubject') private mutationSetSubject: any;

  @Prop() private subjectsAndSub!: Map<string, string[]>;

  private selectSubject(subjectWithSpaces: string) {
    this.mutationSetSubject(subjectWithSpaces);
    this.hideList();
    const subject = subjectWithSpaces.replace(/ /g, '+');
    this.$router.push({ name: 'subject', params: { subject } });
  }

  private hideList() {
    this.$emit('hide-subjects-mobile');
  }

}
